/** Static left-side branding panel of the login screen. */
import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";
import { ShieldCheck, Smartphone, KeyRound } from "lucide-react";
import { FIELD_IMG } from "@/components/auth/loginParts";

const POINTS = [
  { icon: ShieldCheck, t: "Role-based access for Admins, Owners and Helpers" },
  { icon: Smartphone, t: "Mobile-first Helper experience, optimized for field use" },
  { icon: KeyRound, t: "Password & Quick PIN sign-in — works even offline" },
];

export function LoginHero() {
  return (
    <div className="hidden lg:flex relative bg-primary text-primary-foreground p-12 overflow-hidden">
      <img src={FIELD_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-br from-primary/95 via-primary/85 to-primary/70" />
      <div className="relative z-10 flex flex-col h-full justify-between max-w-md">
        <Link to="/" className="flex items-center gap-2.5">
          <BrandLogo size="login" ring={false} bg alt="AnimalMela" className="ring-1 ring-white/30" />
          <span className="font-display font-extrabold text-xl">AnimalMela</span>
        </Link>
        <div>
          <h2 className="font-display text-4xl font-extrabold leading-tight">
            The operating system <br /> for India&apos;s Pashu Haats.
          </h2>
          <p className="mt-4 text-primary-foreground/80 leading-relaxed">
            Secure OTP access. Role-based dashboards. Built for the field.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            {POINTS.map((x) => {
              const I = x.icon;
              return (
                <div key={x.t} className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-primary-foreground/10 grid place-items-center"><I className="w-4 h-4" /></div>
                  <span>{x.t}</span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="text-xs text-primary-foreground/60">© {new Date().getFullYear()} AnimalMela</div>
      </div>
    </div>
  );
}
